import { css } from 'lit';
export default css `
    :host {
        --surface-border-radius: var(--radius-s);
        --surface-box-shadow: var(--surface-flush-thin);
        --surface-cursor: default;
        --surface-background-color: var(--color-ui-08);

        box-sizing: border-box;
        display: block;
        position: relative;
        background-color: var(--surface-background-color);
        border-radius: var(--surface-border-radius);
        box-shadow: var(--surface-box-shadow);
        cursor: var(--surface-cursor);
        transition: box-shadow linear var(--transition-speed);
    }

    :host([variant='none']) {
        --surface-border-radius: none;
        --surface-box-shadow: none;
    }

    :host([variant='thin']) {
        --surface-border-radius: var(--radius-s);
        --surface-box-shadow: var(--surface-flush-thin);
    }

    :host([variant='thick']) {
        --surface-border-radius: var(--radius-s);
        --surface-box-shadow: var(--surface-flush-thick);
    }

    :host([variant='elevated']) {
        --surface-border-radius: var(--radius-l);
        --surface-box-shadow: var(--surface-elevated-not-clickable-under);
    }

    :host([variant='elevated'][clickable]) {
        --surface-box-shadow: var(--surface-elevated);
    }

    :host([variant='elevated-not-clickable-centered']) {
        --surface-box-shadow: var(--surface-elevated-not-clickable-centered);
    }

    :host([variant='elevated-not-clickable-centered-with-backdrop']) {
        --surface-box-shadow: var(--surface-elevated-not-clickable-centered-with-backdrop);
    }

    :host([variant='elevated-not-clickable-above']) {
        --surface-border-radius: none;
        --surface-box-shadow: var(--surface-elevated-not-clickable-above);
    }

    :host([variant='elevated-not-clickable-under']) {
        --surface-border-radius: none;
        --surface-box-shadow: var(--surface-elevated-not-clickable-under);
    }

    :host([variant='floating']) {
        --surface-border-radius: var(--radius-l);
        --surface-box-shadow: var(--surface-floating);
    }

    /* Clickable */

    :host([clickable]) {
        --surface-cursor: pointer;
    }

    :host([variant='elevated'][clickable]:hover) {
        --surface-box-shadow: var(--surface-floating);
    }

    /* Theme: blue */
    :host([theme='blue']) {
        --surface-background-color: var(--color-primary);
    }
`;
